import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import { Scale } from 'react-scaling';


//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;
var noDupes;
//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

//Generates a question from a default question
function GenQuestion(q) {
  //Fills in the question text complete with generated values
  let questionText = q.question;
  let questionLine2 = q.question_line_2;
  let incorrect = [q.option_1, q.option_2, q.option_3, q.option_4, q.option_5, q.option_6];
  let correct = [q.right_answer, q.text_1, q.text_2, q.text_3]


  //Creates an array of answers and fills in the correct answer
  let questionAnswers = [];


for (var i = 0; i < correct.length; i++){
  for (var j = 1; j < correct.length; j++){
    if(correct[i] == correct[j] && i != j){
      correct[j] = "";
    }
  }
}

for (var i = 0; i < incorrect.length; i++){
  for (var j = 1; j < incorrect.length; j++){
    if(incorrect[i] == incorrect[j] && i != j){
      incorrect[j] = "";
    }
  }
}


  for (var i = 0; i < correct.length; i++)
    if (correct[i] !== "" && correct[i] != null){
      if(correct[i].endsWith(' ')){
        correct[i] = correct[i].substring(0,correct[i].length-1);
      }
      questionAnswers.push({ correct: true, value: correct[i], selected: false });
    }


  for (var i = 0; i < incorrect.length; i++)
    if (incorrect[i] !== "" && incorrect[i] != null) {
      if(incorrect[i].endsWith(' ')){
        incorrect[i] = incorrect[i].substring(0,incorrect[i].length-1);

      }
      var found = false;
      for (var o = 0; o < correct.length; o++)
        if (incorrect[i] == correct[o])
          found = true;
      if (!found)
        questionAnswers.push({ correct: false, value: incorrect[i], selected: false });
    }
    console.log(questionAnswers);
    console.log(correct);
    console.log(incorrect);

  //Shuffles the answer array
  shuffleArray(questionAnswers);

  var correctA = q.right_answer;
  if (q.text_1 !== "")
    correctA += ", " + q.text_1;
  if (q.text_2 !== "")
    correctA += ", " + q.text_2;
  if (q.text_3 !== "")
    correctA += ", " + q.text_3;


  //Creates object to return
  let questionObj = {
    question: questionText,
    question_line_2: questionLine2,
    answers: questionAnswers,
    topic_id: q.topic_id,
    correct: correctA
  };

  return questionObj;
}

export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [maxCombo2, setMaxCombo2] = useState(true);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }
  
  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  //if question counter is higher than 3 then reset -refeed
  if(questionCounter > 3){
      questionCounter = 0;
  }

  //Sets the question to a new one
  function newQuestion() {
        
        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 

        //Debugging
         /*
        console.log("tst: lastQ: " + lastQuestion);
      console.log("tst: currQLine: " + currQuestion.question_line_2);
     
        console.log("tst: currQ: " + currQuestion.correct);
        console.log("tst: Counter: " + questionCounter);
        */

        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
             //if current quesiton is same as the previous question then reloop -refeed 
            while (loop) {
                if (currQuestion.question_line_2.toString() != undefined && currQuestion.question_line_2.toString() != "") {
                    if (currQuestion.question_line_2.toString() === lastQuestion.toString()) {
                        console.log("tst: I have looped with extra steps!");
                        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
                    }
                    else if (currQuestion.correct.toString() === lastQuestion.toString()) {
                        console.log("tst: I have looped!");
                        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
                    }
                    else {
                        console.log("tst: Good to go!");
                        loop = false;
                        break;
                    }
                }
                else {
                    break;
                }
		 }   
        } 
        return currQuestion;
    }
  
  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  //Called on click
  async function Toggle(value, callback) {
    if (value) {
      value.selected = !value.selected;
      setMaxCombo2(!maxCombo2);
    }
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
  }

  async function checkResult() {

  //set the current question to the last question -refeed
     questionCounter = questionCounter +1;

     //if the last question only used a question line set last quesiton instead otherwise, do the normal lastqeustion is current - refeed
     if(currQuestion.question_line_2 !== undefined){
        lastQuestion = currQuestion.question_line_2;
	 }
     else{
        lastQuestion = currQuestion.correct;
	 }
     


    if(showColouredFeedback == false)
    {
    var isCorrect = true;
    var count = 0;
    var selected = "";
    for (var i = 0; i < currQuestion.answers.length; i++) {
      if (currQuestion.answers[i].correct !== currQuestion.answers[i].selected)
        isCorrect = false;
      if (currQuestion.answers[i].selected) {
        if (count > 0)
          selected += " | ";
        selected += currQuestion.answers[i].value;
        count++;
      }
    }
    }

    if (count > 0) {
      if (isCorrect) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
            refeedQuestions.pop();
            repeating = false;
        }

        let result = {
          question: currQuestion.question + " " + currQuestion.question_line_2,
          correct: currQuestion.correct,
          incorrect: selected
        };
        newQuestion();
        setNoFeedback([...nofeedback, result]);
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }
        let result = {
          question: currQuestion.question + " " + currQuestion.question_line_2,
          correct: currQuestion.correct,
          incorrect: selected
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();
    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      var sample = newQuestion();
      currQuestion = sample;
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
    }
  }, [status]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)

        return (require("../../assets/"+imageName))

}

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
        Reset();
        props.onBack();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={2200}>
            <Body>
              <div>{currQuestion !== undefined ? (


                <Container>
                  <Question
                    // Remove the 'type', 'disabled', 'javaScriptEnabled', and 'value' props as they are not needed on a styled <div>
                  >
                    {/* The content will be rendered using dangerouslySetInnerHTML */}
                    <div dangerouslySetInnerHTML={{ __html: (currQuestion.question.replace("$", "_")) }} />
                  </Question>
                  {currQuestion.question_line_2 !== "" ?
                    <Question
                      // Remove the 'type', 'disabled', and 'javaScriptEnabled' props
                    >
                      <div dangerouslySetInnerHTML={{ __html: (currQuestion.question_line_2) }} />
                    </Question> : <div></div>}
                  <div
                    style={{
                    }}
                  >
                    {showColouredFeedback == false && currQuestion.answers !== undefined &&
                      currQuestion.answers.map(answer => (
                        <div
                          style={{ width: "100%", margin: "0px" }}>
                          {
                            answer.selected == true ?
                              <SelectedButton
                                value={<div dangerouslySetInnerHTML={answer.value} />}
                                style={{ width: "100%" }}
                                onClick={() => Toggle(answer, true)}
                              >
                                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                               </SelectedButton> :
                              <Button
                                value={<div dangerouslySetInnerHTML={answer.value} />}
                                style={{ width: "100%" }}
                                onClick={() => Toggle(answer, true)}
                              >
                                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                              </Button>
                          }</div>

                          
                      )
                      
                      )}

                    {showColouredFeedback == true && currQuestion.answers !== undefined &&
                      currQuestion.answers.map(answer => (
                        <div
                          style={{ width: "100%", margin: "0px" }}>
                          {
                              <Button
                                value={<div dangerouslySetInnerHTML={answer.value} />}
                                style={{ flex: 1, width: "100%" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                              >
                                <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                              </Button>
                          }</div>

                      ))}
                  </div>

                  <Button
                    style={{ alignSelf: "center", width: "50%", margin: "20px" }}
                    onClick={() => checkResult()}
                  >
                    <span>{<div dangerouslySetInnerHTML={{ __html: ("Submit") }} />}</span>
                  </Button>
                </Container>

              ) : <h1></h1>}
              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
            width: 100%;
            height: 100%;
  background-image: url("${props => props.gameBackground}");
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 40px;
          `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
          `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
            margin-left: 50px;
          `;

const Container = styled.div`
          width:100%
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const Question = styled.div`
            background: #FFF;
            user-select: none;
            width: 1000px;
            height: 100%;
            line-height: 50px;
            font-size: 4em;
            margin: 5px 0px;
            text-align: center;
            border: none;
            border-radius: 10px;
            padding: 0.5em;
            margin-bottom: 2%;
          `;

const Button = styled.div`
            text-align: center;
            width: 10%;
            height: 100%;
            line-height: 40px;
            font-size: 4em;
            margin: 0px;
            color: #fff;
            user-select: none;
            background: rgb(234, 146, 19);
            background: linear-gradient(
              0deg,
              rgba(234, 146, 19, 1) 0%,
              rgba(255, 186, 32, 1) 100%
            );
            border: 2px solid #e88f12;
            padding: 0.5em;
            box-sizing: border-box;
            border-radius: 0.25em;
            cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
  margin-bottom: 1.5%;
`;

const SelectedButton = styled.div`
    text-align: center;
    width: 10%;
    height: 100%;
    line-height: 40px;
    font-size: 4em;
    margin: 0px;
    color: #fff;
    user-select: none;
    background: rgb(45, 168, 35);
    background: linear-gradient(
      0deg,
      rgba(45, 168, 35, 1) 0%,
      rgba(36, 138, 29, 1) 100%
    );
    border: 2px solid #1d7d16;
    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
  margin-bottom: 1.5%;
`;